import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3181b628"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, "Auto System Classification Results", -1))
const _hoisted_5 = { class: "d-flex gap-2" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_9 = {
  key: 1,
  class: "text-center py-4"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { key: 2 }
const _hoisted_13 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "row g-2 mb-3" }
const _hoisted_16 = { class: "form-label text-uppercase small fw-semibold" }
const _hoisted_17 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_18 = { class: "table-responsive" }
const _hoisted_19 = { class: "table table-striped table-hover align-middle mb-0" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "ms-1"
}
const _hoisted_22 = {
  key: 0,
  class: "flaticon-up-arrow"
}
const _hoisted_23 = {
  key: 1,
  class: "flaticon-down-arrow"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = ["colspan"]
const _hoisted_26 = { class: "d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2" }
const _hoisted_27 = { class: "text-muted small" }
const _hoisted_28 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "btn btn-outline-secondary",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args))),
            disabled: _ctx.loading
          }, " Refresh ", 8, _hoisted_6),
          _createElementVNode("button", {
            class: "btn btn-outline-primary",
            type: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.exportCsv && _ctx.exportCsv(...args))),
            disabled: _ctx.visibleRows.length === 0
          }, " Export CSV ", 8, _hoisted_7)
        ])
      ]),
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.error), 1))
        : (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_ctx.columns.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, "No rows were returned for this table."))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "col-md-4 col-lg-3",
                          key: column
                        }, [
                          _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.formatHeader(column)), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control form-control-sm shadow-none rounded-0",
                            "onUpdate:modelValue": ($event: any) => ((_ctx.columnFilters[column]) = $event),
                            placeholder: `Filter ${_ctx.formatHeader(column)}`
                          }, null, 8, _hoisted_17), [
                            [_vModelText, _ctx.columnFilters[column]]
                          ])
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("table", _hoisted_19, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                              return (_openBlock(), _createElementBlock("th", {
                                key: column,
                                class: "sortable",
                                onClick: ($event: any) => (_ctx.toggleSort(column))
                              }, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.formatHeader(column)), 1),
                                (_ctx.sortState.column === column)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                      (_ctx.sortState.direction === 'asc')
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_22))
                                        : (_openBlock(), _createElementBlock("i", _hoisted_23))
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_20))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleRows, (row, rowIndex) => {
                            return (_openBlock(), _createElementBlock("tr", { key: rowIndex }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                                return (_openBlock(), _createElementBlock("td", { key: column }, _toDisplayString(_ctx.formatCell(row[column])), 1))
                              }), 128))
                            ]))
                          }), 128)),
                          (_ctx.visibleRows.length === 0)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [
                                _createElementVNode("td", {
                                  colspan: _ctx.columns.length,
                                  class: "text-center text-muted py-4"
                                }, " No rows match the current filters. ", 8, _hoisted_25)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, " Showing " + _toDisplayString(_ctx.visibleRows.length.toLocaleString()) + " of " + _toDisplayString(_ctx.rows.length.toLocaleString()) + " rows ", 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-link p-0 text-decoration-none",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args))),
                        disabled: !_ctx.hasActiveFilters
                      }, " Clear filters ", 8, _hoisted_28)
                    ])
                  ]))
            ]))
    ])
  ]))
}